


















import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'ShipButton'
})
export default class ShipButton extends Vue {
  @Prop({ default: false }) show!: boolean;
  @Prop({ default: '发货' }) title!: String;

  shipActionItems: any[] = ['输入发货信息', '顺丰寄件'];

  onShipTypeClick(type: any) {
    switch (type) {
      case '输入发货信息':
        this.$emit('showAddLogistics', type);
        break;
      case '顺丰寄件':
        this.$emit('showShunFeng', type);
        break;
      case '中通寄件':
        this.$emit('showShunFeng', type);
        break;
      default:
        break;
    }
  }
}
